import React from 'react';
import { Button } from '@adobe/react-spectrum';
import { withTheme } from '../../ThemeProvider';
import styles from './PrimaryButton.module.less';
import { variants } from '../../../design-system';

const PrimaryButton = ({ children, themeOverrides, ...props }) => {
  return (
    <div className={styles.container}>
      <Button {...props} variant={variants.PRIMARY}>
        {children}
      </Button>
    </div>
  );
};

PrimaryButton.displayName = 'PrimaryButton';

export default withTheme(PrimaryButton);
